import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const Emails = () => {
  return (
    <>
          <Box className="headingBtnWrap">
            <Typography variant="h1">Emails</Typography>
          </Box>
        </>
  )
}

export default Emails
